/*
 * @Author: luting
 * @Date: 2022-04-19 18:54:08
 * @lastEditors: luting
 * @LastEditTime: 2023-04-04 19:15:25
 */
import React, { useEffect, useState } from 'react';
// import { useIntl } from 'react-intl';
import { getDiskGroupApi, getSuposInstanceApi } from 'root/services/packageManage';
import Detail from './components/Deatil';
import List from './components/List';
import { useSelector } from 'react-redux';

import styles from './index.less';

interface ICapacityData {
  ip?: string;
  actualTotal?: string;
  free?: string | number;
  location?: string;
  lvTotal?: string;
  otherUsed?: string | number;
  packUsed?: string | number;
  vgName?: string;
}

const PackageManage = () => {
  // const intl = useIntl();
  const [capacityData, setCapacityData] = useState<ICapacityData>({});
  const { operationPackage } = useSelector((state: any) => state.packManage);

  useEffect(() => {
    getSuposInstanceApi().then((res) => {
      const { data } = res;
      if (data) {
        getDiskGroupApi().then((res) => {
          const { data } = res;
          setCapacityData(data);
        });
      }
    });
  }, [operationPackage]);

  return (
    <div className={styles.package_manage}>
      <Detail capacityData={capacityData as ICapacityData} />
      <List />
    </div>
  );
};

export default PackageManage;
